import React, { useContext } from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Support = ({ handleShow }) => {
  const theme = localStorage.getItem('theme')

  // language 
  const translations = {
    hi: {
      contact: 'नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।',
      money: 'राशि डालें  ',
      next: 'आगे बड़े ',
      addAmount: 'राशि जोड़ी जानी है ',
      referPerson: 'रेफ़रल | ',
    },
    en: {
      contact: 'Contact Us At Below Platforms.',
      money: 'Enter Amount',
      next: 'Next',
      addAmount: 'Amount to be added',
      referPerson: 'Referral',
    },
  };

  const { language } = useContext(LanguageContext);


  // change theme 
  const styles = {
    backgroundColor: theme === 'light' ? '#fff' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
  };

  return (
    <div>
      <div
        className="leftContainer mb_space_1"
        style={styles}
      >
        <div className="contact_page_new">

  {/* HEADER */}
  <div className="contact_header_card">

    <div className="contact_glow"></div>

    <h2 className="contact_title">
      Contact Support
    </h2>

    <p className="contact_subtitle">
      Our support team is available 24/7 to help you.
    </p>

  </div>

  {/* CONTACT LIST */}
  <div className="contact_list_main">

    {/* EMAIL */}
    {/* <a href="mailto:info@Empireludo.com"  className="contact_item_card">
      <div className="contact_left">
        <div className="contact_icon_box blue_bg">

          <img
            src={
              process.env.PUBLIC_URL +
              "/images/mail.png"
            }
            alt=""
          />

        </div>

        <div>

          <h5>Support Mail</h5>

          <h4>
            {
              JSON.parse(
                localStorage.getItem("sitSetting")
              )?.supportMail
            }
          </h4>

        </div>

      </div>

      <div className="arrow_icon">
        →
      </div>

    </a> */}

    {/* WHATSAPP */}
    {
      JSON.parse(
        localStorage.getItem("sitSetting")
      )?.whatsappSupport && (

        <a
          href={
            JSON.parse(
              localStorage.getItem("sitSetting")
            )?.whatsappSupport
          }
          target="_blank"
          className="contact_item_card"
        >

          <div className="contact_left">

            <div className="contact_icon_box green_bg">

              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/whatsapp.png"
                }
                alt=""
              />

            </div>

            <div>

              <h5>WhatsApp Support</h5>

              <h6>
                { JSON.parse(
              localStorage.getItem("sitSetting")
            )?.whatsappSupport }
              </h6>

            </div>

          </div>

          <div className="arrow_icon">
            →
          </div>

        </a>
      )
    }

    {/* TELEGRAM */}
    {/* {
      JSON.parse(
        localStorage.getItem("sitSetting")
      )?.supportTelegram && (

        <a
          href={
            JSON.parse(
              localStorage.getItem("sitSetting")
            )?.supportTelegram
          }
          target="_blank"
          className="contact_item_card"
        >

          <div className="contact_left">

            <div className="contact_icon_box cyan_bg">

              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/tel.png"
                }
                alt=""
              />

            </div>

            <div>

              <h5>Telegram Support</h5>

              <h6>
                {JSON.parse(
              localStorage.getItem("sitSetting")
            )?.supportTelegram}
              </h6>

            </div>

          </div>

          <div className="arrow_icon">
            →
          </div>

        </a>
      )
    } */}

    {/* PHONE */}
    <a
      href={
        "tel:" +
        JSON.parse(
          localStorage.getItem("sitSetting")
        )?.CompanyMobile
      }
      className="contact_item_card"
    >

      <div className="contact_left">

        <div className="contact_icon_box purple_bg">

          <img
            src={
              process.env.PUBLIC_URL +
              "/images/phone.png"
            }
            alt=""
          />

        </div>

        <div>

          <h5>Call Support</h5>

          <h4>
            {
              JSON.parse(
                localStorage.getItem("sitSetting")
              )?.CompanyMobile
            }
          </h4>

        </div>

      </div>

      <div className="arrow_icon">
        →
      </div>

    </a>

  </div>

</div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
